export default "__VITE_ASSET__Db07EQae__"